import "./index.css"
import "./mobile.css";

function TopBar(props){
    return <div id="top-bar" style={{backgroundColor:props.color}}>
    <h2 className="big-text">{props.text}</h2>
    <h2 className="big-text">{props.subheading}</h2>
    </div>
}


export default TopBar